import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { ResponseDto } from '@models/generic/response.dto';
import { AccountService } from '@services/account.service';
import { Observable, catchError, map } from 'rxjs';
import { LoadingService } from './loading.service';
import { MessageService } from './message.service';

@Injectable()
export class CustomHttpInterceptor implements HttpInterceptor {
  constructor(
    private accountService: AccountService,
    private messageService: MessageService,
    private router: Router,
    private loader: LoadingService,
  ) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    let authReq = request.clone();

    if (this.accountService.token !== undefined) {
      authReq = request.clone({
        headers: request.headers.set(
          'Authorization',
          `Bearer ${this.accountService.token}`,
        ),
      });
    }
    return next.handle(authReq).pipe(
      map((response) => {
        if (response instanceof HttpResponse) {
          let body = response.body;
          if (response.body.data !== undefined) {
            body = response.body.data;
          }
          let newRes: HttpResponse<any> = new HttpResponse({ body });

          return newRes;
        }
        return response;
      }),
      catchError((err: HttpErrorResponse) => {
        let errorBody: ResponseDto<any> = err.error;

        let message = 'Errore sconosciuto';
        if (errorBody.message !== undefined) {
          if (errorBody.message !== null) {
            if (errorBody.message !== '') {
              message = errorBody.message;
            }
          }
        }

        this.messageService.error('Errore', message);

        switch (err.status) {
          case 401:
            this.accountService.clearUserData();
            this.router.navigateByUrl('/login');
            break;
          case 403:
            this.router.navigateByUrl('/home');
            break;
        }
        throw err;
      }),
    );
  }
}
